// extracted by mini-css-extract-plugin
export default {"userOrdersFeed_section":"UserOrders_userOrdersFeed_section__zs6s7","preloader_div":"UserOrders_preloader_div__MbIBK"};